const isProduction = import.meta.env.VITE_NODE_ENV === "production";

import prodStore from "./configureStore.prod";
import devStore from "./configureStore.dev";

const loadedStore = isProduction ? prodStore : devStore;

export const configureStore = loadedStore;
